// function Display(){
//     return(<>Hello I am display</>);
// }
const Display=()=>{
    return(<>Hello I am display arrow function</>)
}
export default Display;